import React, { useState } from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const CheckoutButton = ({ bookingId, checkOutDate, bookingStatus }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const canCheckout = () => {
    // ✅ FIX: Validate inputs first
    if (!checkOutDate || bookingStatus !== 'CONFIRMED') {
      console.warn('⚠️ Missing checkout date or booking not confirmed', {
        checkOutDate,
        bookingStatus
      });
      return false;
    }
    
    try {
      // Parse checkout date safely
      const checkout = new Date(checkOutDate);
      
      // Check if date is valid
      if (isNaN(checkout.getTime())) {
        console.error('❌ Invalid checkout date:', checkOutDate);
        return false;
      }
      
      // Get today's date in UTC
      const today = new Date();
      const todayUTC = new Date(Date.UTC(
        today.getUTCFullYear(), 
        today.getUTCMonth(), 
        today.getUTCDate()
      ));
      
      // Get checkout date in UTC
      const checkoutUTC = new Date(Date.UTC(
        checkout.getUTCFullYear(), 
        checkout.getUTCMonth(), 
        checkout.getUTCDate()
      ));
      
      const daysDiff = Math.floor((todayUTC - checkoutUTC) / (1000 * 60 * 60 * 24));
      
      // Debug logging
      console.log('🗓️ Checkout validation:', {
        checkOutDate,
        todayUTC: todayUTC.toISOString(),
        checkoutUTC: checkoutUTC.toISOString(),
        daysDiff,
        bookingStatus,
        canCheckout: daysDiff === 0 // ONLY on checkout day
      });
      
      // ✅ ONLY allow checkout on the exact checkout date (daysDiff = 0)
      return daysDiff === 0;
      
    } catch (error) {
      console.error('❌ Error in canCheckout:', error);
      return false;
    }
  };

  const handleCheckout = async () => {
    if (!window.confirm('Confirm guest checkout? This will mark the room as available.')) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `http://server.theartkothi.com/api/v1/bookings/${bookingId}/checkout`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        }
      );

      const data = await response.json();

      if (data.status) {
        setSuccess(true);
        alert('✅ Checkout completed! Room is now available for new bookings.');
        // Refresh page after 1 second
        setTimeout(() => window.location.reload(), 1000);
      } else {
        setError(data.message);
      }
    } catch (err) {
      console.error('Checkout error:', err);
      setError('Failed to checkout. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!canCheckout()) {
    const today = new Date();
    const checkout = new Date(checkOutDate);
    const todayUTC = new Date(Date.UTC(
      today.getUTCFullYear(), 
      today.getUTCMonth(), 
      today.getUTCDate()
    ));
    const checkoutUTC = new Date(Date.UTC(
      checkout.getUTCFullYear(), 
      checkout.getUTCMonth(), 
      checkout.getUTCDate()
    ));
    const daysDiff = Math.floor((todayUTC - checkoutUTC) / (1000 * 60 * 60 * 24));
    
    return (
      <div className="checkout-unavailable">
        <button
          disabled
          className="px-4 py-2 bg-gray-300 text-gray-600 rounded cursor-not-allowed flex items-center gap-2"
        >
          
          Checkout Not Available
        </button>
        {/* <p className="text-xs text-gray-500 mt-1">
          {daysDiff < 0 
            ? `Checkout available in ${Math.abs(daysDiff)} day(s)` 
            : daysDiff > 0
            ? `Checkout date was ${daysDiff} day(s) ago`
            : 'Not eligible for checkout'}
        </p> */}
      </div>
    );
  }

  if (success) {
    return (
      <div className="flex items-center text-green-600 font-semibold">
        <CheckCircle size={20} className="mr-2" />
        Checked Out Successfully
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={handleCheckout}
        disabled={loading}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2"
      >
        {loading ? (
          <>
            <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            Processing...
          </>
        ) : (
          <>
            <CheckCircle size={18} />
            Complete Checkout
          </>
        )}
      </button>

      {error && (
        <div className="mt-2 text-red-600 text-sm flex items-center">
          <AlertCircle size={16} className="mr-1" />
          {error}
        </div>
      )}
    </div>
  );
};

export default CheckoutButton;